import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import EmptyState from "@/components/EmptyState";
import { CardSkeleton } from "@/components/Skeletons";
import { FileText } from "lucide-react";

export default function Invoices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/invoices");
        setItems(data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="space-y-5">
      <h1 className="text-3xl font-bold">Invoices</h1>
      {loading ? (
        <CardSkeleton count={3} />
      ) : items.length === 0 ? (
        <EmptyState
          icon={FileText}
          title="No invoices yet"
          description="Mark a job as Done and a draft invoice will be created here automatically."
        />
      ) : (
        <div className="space-y-2">
          {items.map((i) => (
            <Link key={i.id} to={`/invoices/${i.id}`} data-testid={`invoice-row-${i.id}`}>
              <div className="bg-white rounded-2xl border border-slate-200 p-4 hover:border-blue-300 hover:shadow-sm transition-all active:scale-[0.99] mb-2">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-semibold text-slate-900">{i.number}</div>
                    <div className="text-sm text-slate-500 mt-0.5 truncate">{i.customer_name}</div>
                  </div>
                  <div className="flex items-center gap-3 flex-shrink-0">
                    <div className="font-bold text-lg" style={{ fontFamily: "Outfit" }}>
                      ${(i.total_amount || 0).toFixed(2)}
                    </div>
                    <StatusBadge status={i.status} />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
